import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import CacheKeys from "../../../cache/CacheKeys";
import CacheManager from "../../../cache/CacheManager";
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";
import ComplianceRetailReportPageUI from "./ComplianceRetailReportPageUI";

class ComplianceRetailReportPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      complianceReportList: null,
      selectedFilter: "all",
      accountList: [],
      selectedStatus: "all",
      selectedNoticeSent: "all",
      searchFilter: "",
      showDsraDip: false,
    };
  }

  render() {
    let filterOptionList = [
      { value: "all", label: "All" },
      { value: "financial", label: "Financial" },
      { value: "others", label: "Others" },
    ];
    let statusList = [
      { value: "all", label: "All" },
      // { value: 'complied', label: 'Complied' },
      { value: "not_complied", label: "Not complied" },
    ];
    let noticeSentList = [
      { value: "all", label: "All" },
      { value: "notice_sent", label: "Notice Sent" },
    ];
    return (
      <ComplianceRetailReportPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        complianceReportList={this.state.filteredList}
        yearMonth={this.state.yearMonth}
        lastCronRunTime={this.state.lastCronRunTime}
        onRefreshClick={this.onRefreshClick}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        selectedFilter={this.state.selectedFilter}
        onFilterChange={this.onFilterChange}
        filterOptionList={filterOptionList}
        selectedStatus={this.state.selectedStatus}
        onStatusChange={this.onStatusChange}
        statusList={statusList}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        onDownloadComplianceReport={this.onDownloadComplianceReport}
        //
        showDsraDip={this.state.showDsraDip}
        onDsraDipClick={() => {
          this.setState({ showDsraDip: !this.state.showDsraDip });
        }}
        //
        selectedNoticeSent={this.state.selectedNoticeSent}
        onNoticeSentChange={this.onNoticeSentChange}
        noticeSentList={noticeSentList}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context;
    this.getComplianceReport(context, "", "");
  }

  onPreviousClick = () => {
    let context = this.props.context;
    this.getComplianceReport(
      context,
      this.state.previousYear,
      this.state.previousMonth
    );
  };

  onNextClick = () => {
    let context = this.props.context;
    this.getComplianceReport(
      context,
      this.state.nextYear,
      this.state.nextMonth
    );
  };

  // getComplianceReport(context, year, month) {
  //   year = year === undefined ? "" : year;
  //   month = month === undefined ? "" : month;

  //   let cacheManager = new CacheManager({
  //     resource: `/api/su/loans/compliance/v2/yearMonth`,
  //     cacheKey: CacheKeys.ComplianceReport(year, month),
  //     callback: this.getComplianceReportCallback,
  //     ttlInSecs: 600,
  //   });
  //   cacheManager.getObject2(context, {}, { year: year, month: month });
  // }
  getComplianceReport(context, year, month) {
    year = year === undefined ? "" : year;
    month = month === undefined ? "" : month;

    let cacheManager = new CacheManager({
      resource: `/api/su/loans/compliance/v3/yearMonth`,
      cacheKey: CacheKeys.ComplianceReport(year, month),
      callback: this.getComplianceReportCallback,
      ttlInSecs: 600,
    });
    cacheManager.getObject2(context, {}, { year: year, month: month });
  }

  getComplianceReportCallback = (response) => {
    this.setState(
      {
        complianceReportList: response.complianceReportList2,
        errorList: response.errorList,
        yearMonth: response.yearMonth,
        lastCronRunTime: response.lastCronRunTime,
        year: response.yearMonth.year,
        month: response.yearMonth.month,
        previousYear: response.yearMonth.prevYear,
        previousMonth: response.yearMonth.prevMonth,
        nextYear: response.yearMonth.nextYear,
        nextMonth: response.yearMonth.nextMonth,
      },
      this.applyFilter
    );
  };

  onDownloadComplianceReport = () => {
    let context = this.props.context;
    this.setState({ onDownloadComplianceReportRequested: true });

    RestApiUtils.post(
      context,
      `/api/su/loans/compliance/fileDownloadSignedUrl?isNonRetail=false`,
      this.getDownloadComplianceReportCallback,
      {
        year: this.state.year,
        month: this.state.month,
      }
    );
  };

  getDownloadComplianceReportCallback = (response) => {
    this.setState({ onDownloadComplianceReportRequested: false });
    if (response.errorList.length === 0) {
      const link = document.createElement("a");
      link.href = response.signedUrl.signedUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  onFilterChange = (selectedOption) => {
    let selectedFilter = selectedOption.value;
    this.setState({ selectedFilter }, this.applyFilter);
  };

  onStatusChange = (selectedOption) => {
    this.setState({ selectedStatus: selectedOption.value }, this.applyFilter);
  };

  onNoticeSentChange = (selectedOption) => {
    this.setState(
      { selectedNoticeSent: selectedOption.value },
      this.applyFilter
    );
  };

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value;
    this.setState({ searchFilter }, this.applyFilter);
  };

  applyFilter() {
    const {
      complianceReportList,
      selectedFilter,
      selectedStatus,
      searchFilter,
      selectedNoticeSent,
    } = this.state;

    let filteredList = complianceReportList;

    // Step 1: Filter by financial/others category
    if (selectedFilter !== "all") {
      filteredList = filteredList
        .map(function(account) {
          var filteredLoanComplianceList = (account.loanComplianceList || [])
            .map(function(loanCompliance) {
              var filteredComplianceCodeList = (
                loanCompliance.complianceCodeList || []
              )
                .map(function(complianceCode) {
                  var filteredClauseList = complianceCode.clauseList || [];

                  var financialClauses = [
                    "dsra_dip_in_case_of_emi_default",
                    "dsra_dip_in_case_of_levying_of_penal_charges",
                  ];

                  var othersClauses = [
                    "share_certificate",
                    "share_transfer_form",
                    "form_chg_1",
                    "pledge_sequence_number",
                    "extension_letter",
                    "tax_invoices",
                    "transit_insurance",
                    "project_ppa_vehicle_insurance",
                    "net_metering_certificate",
                    "registration_certificates",
                    "non_compliance_of_financial_covenants",
                    "non_compliance_of_reps_and_warranties",
                    "non_compliance_of_negative_covenants",
                    "non_compliance_of_information_covenants",
                  ];

                  if (selectedFilter === "financial") {
                    var hasFinancialClause = filteredClauseList.some((clause) =>
                      financialClauses.includes(clause.legalLanguageCode)
                    );

                    if (
                      complianceCode.complianceCode === "emi_default_compliance" ||
                      hasFinancialClause
                    ) {
                      return {
                        ...complianceCode,
                        clauseList: filteredClauseList.filter((clause) =>
                          financialClauses.includes(clause.legalLanguageCode)
                        ),
                      };
                    }
                  } else if (selectedFilter === "others") {
                    var hasOthersClause = filteredClauseList.some((clause) =>
                      othersClauses.includes(clause.legalLanguageCode)
                    );

                    if (hasOthersClause) {
                      return {
                        ...complianceCode,
                        clauseList: filteredClauseList.filter((clause) =>
                          othersClauses.includes(clause.legalLanguageCode)
                        ),
                      };
                    }
                  }

                  return null;
                })
                .filter(Boolean);

              return filteredComplianceCodeList.length > 0
                ? {
                    ...loanCompliance,
                    complianceCodeList: filteredComplianceCodeList,
                  }
                : null;
            })
            .filter(Boolean);

          return filteredLoanComplianceList.length > 0
            ? { ...account, loanComplianceList: filteredLoanComplianceList }
            : null;
        })
        .filter(Boolean);
    }

    // Step 2: Filter by compliance clause status
    if (selectedStatus === "complied") {
      filteredList = filteredList
        .map((account) => {
          return {
            ...account,
            loanComplianceList: account.loanComplianceList
              ? account.loanComplianceList.filter((loan) => loan.complied)
              : [],
          };
        })
        .filter((account) => account.loanComplianceList.length > 0);
    } else if (selectedStatus === "not_complied") {
      filteredList = filteredList
        .map((account) => {
          return {
            ...account,
            loanComplianceList: account.loanComplianceList
              ? account.loanComplianceList.filter((loan) => !loan.complied)
              : [],
          };
        })
        .filter((account) => account.loanComplianceList.length > 0);
    } else {
      filteredList = filteredList;
    }

    // Step 3: Notice Sent filter
    if (selectedNoticeSent === "notice_sent") {
      filteredList = filteredList
        .map((account) => {
          const filteredComplianceNoticeList = (
            account.complianceNoticeList || []
          ).filter((notice) => notice.numberOfNoticesSent > 0);

          return filteredComplianceNoticeList.length > 0
            ? { ...account, complianceNoticeList: filteredComplianceNoticeList }
            : null;
        })
        .filter(Boolean);
    }

    // Step 4: Filter by search filter
    if (searchFilter) {
      const searchFilterLower = searchFilter.toLowerCase();
      filteredList = filteredList.filter((account) =>
        account.accountName.toLowerCase().includes(searchFilterLower)
      );
    }

    this.setState({ filteredList });
  }

  onRefreshClick = () => {
    CacheManager.removeObject(
      CacheKeys.ComplianceReport(this.state.year, this.state.month)
    );
    this.setState(
      {
        filteredList: null,
        errorList: null,
        selectedFilter: "all",
        selectedStatus: "all",
        searchFilter: "",
      },
      this.getComplianceReport(
        this.props.context,
        this.state.year,
        this.state.month
      )
    );
  };
}

export default withRouter(ComplianceRetailReportPageSF);
